export default {
    fsmRoute_eta_route_etalink: "ETA LINK",
    fsmRoute_eta_route_etalinkInfo: "When you enable this feature, a link will be sent to your chosen contacts so they can track the route according to the route duration.",
    fsmRoute_eta_route_sharecamera: "Share camera snapshot (if camera avaiable)",
    fsmRoute_eta_route_sharecamerainfo: "This option enables the display of vehicle cameras to the user who tracks from the public link.",
    fsmRoute_eta_route_recipients: "Recipients",
    fsmRoute_eta_route_recipients_chose: "Choose Contact Method:",
    fsmRoute_eta_route_recipients_notes: "ETA Notes",
    fsmRoute_eta_route_recipients_notesinfo: "Add aditional info"
};